module.exports = __webpack_public_path__ + "images/accents/accent-chart-skateboarder@1x-4c66c6d619f28b5f9799e2287655ccf7.webp";